import React from 'react';
import {  useCurrentBreakpointName } from 'react-socks';
import InfoBanner from 'app/components/InfoBanner/InfoBanner.jsx';

const MobileOnlyBanner = (props) => {
    const breakpoint = useCurrentBreakpointName();

    if (breakpoint === "mobile") {
        return (
            <InfoBanner type="trial" content={props.bannerContent} closeCallback={props.closeInfoBanner}/>
        );
    }

    return null;
}

export default MobileOnlyBanner;
